import { config } from "./config";
import getUser from "./getUser";

/**
 * This function takes in a report url and returns the constructed report link
 * with the access token appended to the url.
 * @param reportUrl 
 * @returns string
 */
export const buildPrivatePdfLink = (reportUrl: string) => {
  const user = getUser();
  return `${config.apiUrl}${reportUrl}?j=${user?.access_token}`;
}